module.exports = __webpack_public_path__ + "static/media/gts17.68971737.png";